import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { IUserAllResponse } from "../models/IUser.model";
import { URLConfig } from "../network/urlStore";

export const getRetailers = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<IUserAllResponse> => {
  let url = URLConfig.getUsersMasterDataURL();
  
  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IUserAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching retailer data", error);
      }
    );
  });
};

export const getRetailersNextPage = (
  nextPageURI: string
): Observable<IUserAllResponse> => {
  const url = URLConfig.getUsersNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (response) => {
        if (response) {
          const retailersResponse =
            response as unknown as IUserAllResponse;
          subscriber.next(retailersResponse);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching retailers next page", error);
      }
    );
  });
};

export const getContentLengthForRetailer = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getUsersMasterDataURL();

  for (const param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching retailer content length:", error);
      });
  });
};

export const updateRetailer = (
  retailerPayload: any,
  retailerId: string
): Observable<any> => {
  const url = URLConfig.updateUserMasterDataURL(retailerId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, retailerPayload).then(
      (res) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating retailer", error);
      }
    );
  });
};
